import Icon from '../components/Icon';

const CheckSm = Icon(
  'check-sm',
  <>
    <path d="M16.555 9.298a1 1 0 0 1-.01 1.414l-5.157 5.083a1 1 0 0 1-1.396.007l-2.53-2.44a1 1 0 0 1 1.39-1.44l1.827 1.764 4.462-4.398a1 1 0 0 1 1.414.01" />
  </>
);

export default CheckSm;
